import { Field, ID, InputType } from 'type-graphql'
import { QueryArgs } from '../../action'
import type { IAction } from '../../action/IAction'
import type { AiCreditTransaction } from './AiCreditTransaction'
import type { AiCreditTransactionTotals } from './AiCreditTransactionTotals'

/** Same shape as `GetAiCreditTransactionListTotalsArgs` — `options` is inherited but unused by `GetCreditLedgerTotals`. */
@InputType()
export class GetCreditLedgerTotalsArgs extends QueryArgs<AiCreditTransaction> {
  /** The school (pool account) owner whose ledger is being totaled. */
  @Field(() => ID)
  ownerId: string
}

export interface IGetCreditLedgerTotals extends IAction<AiCreditTransactionTotals, GetCreditLedgerTotalsArgs> {}
